import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import SearchBar from '../components/SearchBar'
import TrackCard from '../components/TrackCard'
import LoadingSpinner from '../components/LoadingSpinner'
import { searchTracks } from '../services/api'
import './SearchPage.css'

function SearchPage() {
  const [searchQuery, setSearchQuery] = useState('')
  const [results, setResults] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [genreFilter, setGenreFilter] = useState('all')
  const navigate = useNavigate()

  const handleSearch = async (query) => {
    if (!query.trim()) return

    setLoading(true)
    setError(null)

    try {
      const data = await searchTracks(query, genreFilter)

      // CRITICAL: Check if response is actually an array
      if (!Array.isArray(data)) {
        console.error('API returned non-array response:', data)
        setError(data.error || data.message || 'Failed to search tracks. Please try again.')
        setResults([])
        return
      }

      setResults(data)
    } catch (err) {
      setError('Failed to search tracks. Please try again.')
      console.error('Search error:', err)
      setResults([])
    } finally {
      setLoading(false)
    }
  }

  const handleAnalyzeTrack = async (track) => {
    // Navigate to recommendations page with track data
    navigate(`/recommendations/${track.id}`, { state: { track } })
  }

  return (
    <div className="search-page">
      <div className="search-hero">
        <h2>Find Your Perfect Blend</h2>
        <p>Search SoundCloud for DnB, dubstep, and 140 tracks</p>
      </div>

      <SearchBar
        value={searchQuery}
        onChange={setSearchQuery}
        onSearch={handleSearch}
        placeholder="Search for tracks (e.g., Noisia, dubstep, neurofunk)..."
      />

      <div className="genre-filters">
        <button
          className={`filter-btn ${genreFilter === 'all' ? 'active' : ''}`}
          onClick={() => setGenreFilter('all')}
        >
          All Genres
        </button>
        <button
          className={`filter-btn ${genreFilter === 'dnb' ? 'active' : ''}`}
          onClick={() => setGenreFilter('dnb')}
        >
          Drum & Bass
        </button>
        <button
          className={`filter-btn ${genreFilter === 'dubstep' ? 'active' : ''}`}
          onClick={() => setGenreFilter('dubstep')}
        >
          Dubstep
        </button>
        <button
          className={`filter-btn ${genreFilter === '140' ? 'active' : ''}`}
          onClick={() => setGenreFilter('140')}
        >
          140 / Grime
        </button>
      </div>

      {loading && (
        <div className="loading-container">
          <LoadingSpinner />
          <p>Searching SoundCloud...</p>
        </div>
      )}

      {error && (
        <div className="error-message">
          {error}
        </div>
      )}

      {results.length > 0 && !loading && (
        <div className="results-section">
          <h3>Search Results ({results.length})</h3>
          <div className="results-grid">
            {results.map(track => (
              <TrackCard
                key={track.id}
                track={track}
                onAnalyze={handleAnalyzeTrack}
              />
            ))}
          </div>
        </div>
      )}

      {results.length === 0 && !loading && searchQuery && (
        <div className="no-results">
          <p>No tracks found. Try a different search term.</p>
        </div>
      )}
    </div>
  )
}

export default SearchPage
